// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2PI-b","search":"Settings_search__73uEW","filter":"Settings_filter__3t_w6"};